"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _off = _interopRequireDefault(require("dom-helpers/events/off"));
var _on = _interopRequireDefault(require("dom-helpers/events/on"));
var _invariant = _interopRequireDefault(require("invariant"));
var _createPath = _interopRequireDefault(require("./utils/createPath"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BrowserProtocol = /*#__PURE__*/
function () {
  function BrowserProtocol() {
    this._keyPrefix = Math.random().toString(36).slice(2, 8);
    this._keyIndex = 0;
    this._index = null;
  }
  var _proto = BrowserProtocol.prototype;
  _proto.init = function init() {
    var _window$location = window.location,
      pathname = _window$location.pathname,
      search = _window$location.search,
      hash = _window$location.hash;
    var _ref = window.history.state || {},
      key = _ref.key,
      _ref$index = _ref.index,
      index = _ref$index === void 0 ? 0 : _ref$index,
      state = _ref.state;
    var delta = this._index != null ? index - this._index : 0;
    this._index = index;
    return {
      action: 'POP',
      pathname: pathname,
      search: search,
      hash: hash,
      key: key,
      index: index,
      delta: delta,
      state: state
    };
  };
  _proto.subscribe = function subscribe(listener) {
    var _this = this;
    var onPopState = function onPopState() {
      listener(_this.init());
    }; // TODO: On most versions of IE, we need a hashChange listener for hash-
    // only changes.

    (0, _on["default"])(window, 'popstate', onPopState);
    return function () {
      return (0, _off["default"])(window, 'popstate', onPopState);
    };
  };
  _proto.transition = function transition(location) {
    var action = location.action,
      state = location.state;
    var push = action === 'PUSH';
    !(push || action === 'REPLACE') ? process.env.NODE_ENV !== "production" ? (0, _invariant["default"])(false, "Unrecognized browser protocol action: %s.", action) : invariant(false) : void 0;
    var delta = push ? 1 : 0;
    var extraState = this._createExtraState(delta);
    var browserState = _extends({
      state: state
    }, extraState);
    var path = (0, _createPath["default"])(location);
    if (push) {
      window.history.pushState(browserState, null, path);
    } else {
      window.history.replaceState(browserState, null, path);
    }
    return _extends({}, location, extraState, {
      delta: delta
    });
  };
  _proto.go = function go(delta) {
    window.history.go(delta);
  };
  _proto.createHref = function createHref(location) {
    return (0, _createPath["default"])(location);
  };
  _proto._createExtraState = function _createExtraState(delta) {
    var keyIndex = this._keyIndex++;
    this._index += delta;
    return {
      key: this._keyPrefix + ":" + keyIndex.toString(36),
      index: this._index
    };
  };
  return BrowserProtocol;
}();
exports["default"] = BrowserProtocol;
module.exports = exports["default"];